import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["aria-label"]

import VPAutoLink from '@theme/VPAutoLink.vue'
import VPNavbarDropdown from '@theme/VPNavbarDropdown.vue'
import { useNavbarConfig } from '@theme/useNavbarConfig'
import { useNavbarRepo } from '@theme/useNavbarRepo'
import { useNavbarSelectLanguage } from '@theme/useNavbarSelectLanguage'
import { useThemeLocaleData } from '@theme/useThemeData'
import { DeviceType, useUpdateDeviceStatus } from '@theme/useUpdateDeviceStatus'
import { computed, ref } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'VPNavbarItems',
  setup(__props) {

const navbarConfig = useNavbarConfig()
const navbarSelectLanguage = useNavbarSelectLanguage()
const navbarRepo = useNavbarRepo()

const isMobile = ref(false)

const navbarLabel = computed(() => {
  const themeLocale = useThemeLocaleData()
  return themeLocale.value.navbarLabel ?? 'site navigation'
})

const navbarLinks = computed(() => [
  ...navbarConfig.value,
  ...navbarSelectLanguage.value,
  ...navbarRepo.value,
])

useUpdateDeviceStatus(
  DeviceType.Mobile,
  (mobileDesktopBreakpoint: number): void => {
    // avoid overlapping of long title and long navbar links
    isMobile.value = window.innerWidth < mobileDesktopBreakpoint
  },
)

return (_ctx: any,_cache: any) => {
  return (navbarLinks.value.length)
    ? (_openBlock(), _createElementBlock("nav", {
        key: 0,
        class: "vp-navbar-items",
        "aria-label": navbarLabel.value
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(navbarLinks.value, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            key: item.text,
            class: "vp-navbar-item"
          }, [
            ('children' in item)
              ? (_openBlock(), _createBlock(VPNavbarDropdown, {
                  key: 0,
                  class: _normalizeClass({ mobile: isMobile.value }),
                  config: item
                }, null, 8, ["class", "config"]))
              : (_openBlock(), _createBlock(VPAutoLink, {
                  key: 1,
                  config: item
                }, null, 8, ["config"]))
          ]))
        }), 128))
      ], 8, _hoisted_1))
    : _createCommentVNode("", true)
}
}

})